import { connect } from 'react-redux';
import * as formsSelectors from 'ContentData/selectors/forms';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import PagesList from './PagesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.parentPages.panel.${key}`;
const mapStateToProps = (state, props) => ({
  pages: formsSelectors.getParentPages(state, props.formGuid)
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
const PagesSidePanel = ({
  pages,
  onClose
}) => /*#__PURE__*/_jsxs(Panel, {
  "data-selenium": "form-pages-panel",
  children: [/*#__PURE__*/_jsx(DialogCloseButton, {
    onClick: onClose
  }), /*#__PURE__*/_jsx(PanelHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('header')
      })
    })
  }), /*#__PURE__*/_jsx(PanelBody, {
    children: /*#__PURE__*/_jsx(PanelSection, {
      children: /*#__PURE__*/_jsx(PagesList, {
        pages: pages
      })
    })
  })]
});
export default connector(PagesSidePanel);